module.exports = __webpack_public_path__ + "img/Like-Fill.907c9406.svg";